export default __webpack_public_path__ + "static/media/torso-top-front.dc11ef00.png";